import { makeStyles } from '@mui/styles';
import { Colors } from '../../../assets/styles';

const useStyles = makeStyles({
  groupHeader: {
    color: Colors.Blue,
    textAlign: 'center',
    marginBottom: '20px',
  },
});

export default useStyles;
